import { InjectionToken } from '@angular/core';
import type { Environment } from './models';

export type AppConfig = Environment & {
    isProd: boolean;
    isDemo: boolean;
    useProductionUi: boolean;
};

export function buildAppConfig(
    env: Environment,
    options: { useProductionUi?: boolean } = {}
): AppConfig {
    const envName = env.env;
    return {
        ...env,
        isProd: envName === 'production',
        isDemo: envName === 'demo',
        useProductionUi:
            envName === 'production' || options.useProductionUi === true,
    };
}

export const APP_CONFIG_TOKEN = new InjectionToken<AppConfig>('app.config');
